export default function Footer({ children, prefix }) {
  return (
    <div className={`${prefix}flex ${prefix}justify-between ${prefix}items-center`}>
      {children}
    </div>
  );
}
